export default __webpack_public_path__ + "static/media/original.f456184a.png";